import { Injectable } from '@angular/core';
import { CanActivate } from '@angular/router';
import { AuthFactoryService } from '../authFactory.service';

@Injectable({ providedIn: 'root' })
export class OIDCSigninGuard implements CanActivate {
  constructor(private authFactoryService: AuthFactoryService) {}

  canActivate() {
    this.authFactoryService.redirectToLogin();
    return true;
  }
}
